<template>
  <div>
    <h4>Payment {{payment.sku}} rewards</h4>

    <table v-if="hasRewards" class="table text-nowrap">
      <thead class="thead-dark">
        <tr>
          <th scope="col">Proto</th>
          <th scope="col" class="text-right">Amount</th>
        </tr>
      </thead>
      <tr
        v-for="reward in payment.rewards"
        :key="reward.id"
      >
        <td>
          {{reward.protoId | getProtoAlias}}
        </td>
        <td class="text-right">
          {{reward.amount}}
        </td>
      </tr>
    </table>

  </div>
</template>

<script>
export default {
  name: 'OfferPayment',

  props: {
    payment: {
      type: Object,
      required: true,
    }
  },

  computed: {
    hasRewards() {
      if(this.payment === null) {
        return false;
      }
      if(!('rewards' in this.payment)) {
        return false;
      }
      return this.payment.rewards.length > 0;
    },
  },
};
</script>

<style scoped>
.table {
  max-width: 300px;
}
</style>